export const PHPersonalIntentOptions = {
  file_taxes: { label: 'File taxes', value: 'File taxes' },
  help_with_tax_issues: {
    label: 'Help with tax issues',
    value: 'Help with tax issues'
  },
  answer_general_questions: {
    label: 'Answer general questions',
    value: 'Answer general questions'
  },
  something_else: { label: 'Something else', value: 'Something else' }
} as const;
